<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>Candidate Details</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Candidate Details</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container back-link">
    <a routerLink="/employer/candidate-list" class="cursor_pointer h5"><i class="fa fa-angle-double-left me-2"></i>Back</a>
</div>



<div class="single-profile-area pt-100">
    <div [ngClass]="!!approvedStatus ? 'container-fluid p-5' : 'container p-5'">
        <div class="row">
            <div class="col-lg-3" *ngIf="!!approvedStatus">
                <div class="single-profile-item">
                    <!-- <ng-container
                    *ngIf="
                        candidateInfo?.candidateImageDetails?.imageUrl &&
                            candidateInfo?.candidateImageDetails?.imageUrl.trim() !==
                                '';
                        else avatarImage
                    "
                >
                    <img
                        [src]="
                            candidateInfo?.candidateImageDetails?.imageUrl
                        "
                        class="profile_images"
                        alt="Profile"
                    />
                </ng-container>
                <ng-template #avatarImage>
                    <img
                        src="../../../assets/dummy/dummy-candidate.png"
                        class="profile_images"
                        alt="Profile"
                    />
                </ng-template> -->

                <div class="single-profile-left">
                    <div class="single-profile-contact">
                        <h3>Contact Info</h3>

                        <ul class="unordered-list">
                            <li>
                                <i class="icofont-ui-call"></i>
                                <a href="tel:+07554332322"
                                    >Call :
                                    {{
                                        candidateInfo.phoneNumber
                                            ? candidateInfo.phoneNumber
                                            : "***"
                                    }}</a
                                >
                            </li>
                            <li>
                                <i class="icofont-email"></i>
                                <a href="mailto:hello&#64;peof.com">{{
                                    candidateInfo.email
                                        ? candidateInfo.email
                                        : "***"
                                }}</a>
                            </li>
                            <li>
                                <i class="icofont-location-pin"></i
                                >{{
                                    candidateInfo.city
                                        ? candidateInfo.city
                                        : "***"
                                }}
                            </li>
                        </ul>
                    </div>

                    <div class="single-profile-skills">
                        <div>
                            <h3>Skills</h3>
                            @for (data of candidateInfo?.skills; track
                            $index) {
                            <p>{{ data?.skill }}</p>

                            } @empty {
                            <p>No Skills</p>
                            }
                        </div>
                    </div>

                    <div class="single-profile-skills">
                        <div>
                            <h3>Resume</h3>
                            <div *ngIf="candidateInfo.candidateResumeDetails?.imageUrl; else noResume">
                                <ng-container *ngIf="candidateInfo.candidateResumeDetails">
                                    <a class="certificate" [href]="candidateInfo.candidateResumeDetails.imageUrl" target="_blank" rel="noopener noreferrer" download="{{ candidateInfo.candidateResumeDetails.imageName }}">
                                     <p  >{{ candidateInfo.candidateResumeDetails.imageName }}</p> 
                                    </a>
                                  </ng-container>
                            </div>
                        
                            <!-- No Resume message -->
                            <ng-template #noResume>
                                <p>No Resume Available</p>
                            </ng-template>
                        </div>
                    </div>

                    <div class="single-profile-skills">
                        <div>
                            <h3>Cover Letter</h3>
                            <div *ngIf="candidateInfo.candidateCoverLetterDetails?.imageUrl; else noCoverLetter">
                                <ng-container *ngIf="candidateInfo.candidateCoverLetterDetails">
                                    <a class="certificate" [href]="candidateInfo.candidateCoverLetterDetails.imageUrl" target="_blank" rel="noopener noreferrer" download="{{ candidateInfo.candidateResumeDetails.imageName }}">
                                     <p  >{{ candidateInfo.candidateCoverLetterDetails.imageName }}</p> 
                                    </a>
                                  </ng-container>
                            </div>
                            <!-- No Resume message -->
                            <ng-template #noCoverLetter>
                                <p>No Cover Letter</p>
                            </ng-template>
                        </div>
                    </div>
                </div>
                </div>





         
            </div>
            
            <div class="col-lg-8" >
                <div class="scroll-container">
                <div class="single-profile-item">
                    <div class="single-profile-right">
                        <div class="single-profile-name">
                            <ng-container *ngIf="candidateInfo?.firstName || candidateInfo?.middleName || candidateInfo?.lastName ; else defaultName">
                                <h2>{{ candidateInfo?.firstName }} {{ candidateInfo?.middleName }} {{ candidateInfo?.lastName }}</h2>
                            </ng-container>
                            <ng-template #defaultName>
                                <h2>{{candidateInfo?.publicName}}</h2>
                            </ng-template>
                            <span>{{candidateInfo?.category ? candidateInfo?.category : "***"}}</span>
                            <!-- <a routerLink="/">View CV <i class="icofont-eye-alt"></i></a>
                            <a routerLink="/">Download CV <i class="icofont-download"></i></a> -->
                        </div>

                        <div class="single-profile-textarea">
                            <div class="single-profile-heading">
                                <span></span>
                                <h3>Job Title</h3>
                            </div>

                            <div class="single-profile-paragraph">
                                <p class="single-profile-p">{{candidateInfo?.jobTitle ? candidateInfo?.jobTitle : "No Job Title Exist"}}</p>
                            </div>
                            <div class="single-profile-heading">
                                <span></span>
                                <!-- <h3>Description</h3> -->
                                <h3>Personal summary</h3>
                            </div>

                            <div class="single-profile-paragraph">
                                <p class="single-profile-p">{{candidateInfo?.description ? candidateInfo?.description : "No Description"}}</p>
                            </div>

                            <div class="single-profile-heading">
                                <span></span>
                                <h3>Education</h3>
                            </div>

                            <div class="single-profile-paragraph">
                                <ul class="unordered-list">
                                    <!-- Loop through the qualifications array -->
                                    <ng-container *ngIf="candidateInfo?.qualifications?.length; else noEducation">
                                        <li *ngFor="let data of candidateInfo.qualifications; let i = index">
                                            <b>{{ i + 1 }}</b>: {{ data?.courseOrQualification }}
                                            <span *ngIf="data?.finishedYear">({{ data?.finishedYear }})</span>
                            
                                            <!-- <b><p *ngIf="data.educationCertificate?.imageName">Certificate</p></b> -->
                            
                                            <!-- If certificate has a valid URL -->
                                            <div *ngIf="data.educationCertificate?.imageName" class="d-flex align-items-center">
                                                <a class="certificate" [href]="data.educationCertificate.imageUrl"
                                                   target="_blank"
                                                   rel="noopener noreferrer"
                                                   [attr.download]="!data.educationCertificate.imageMimeType.startsWith('image/') ? data.educationCertificate.imageName : null">
                                                <p class="fw-bold">{{ data.educationCertificate.imageName }}</p>  
                                                </a>
                                              </div>
                                        </li>
                                    </ng-container>
                            
                                    <!-- No Education Available -->
                                    <ng-template #noEducation>
                                        <li>No Education</li>
                                    </ng-template>
                                </ul>
                            </div>



                            <div class="single-profile-heading">
                                <span></span>
                                <h3>Years Of Experiences</h3>
                            </div>
                            <div class="single-profile-paragraph">
                                <ng-container *ngIf="candidateInfo?.yearsOfExperience?.length > 0 ; else noExperience">
                                    <ul>
                                    <li *ngFor="let experience of candidateInfo?.yearsOfExperience">
                                        
                                        <div class="d-flex justify-content-between w-100">
                                            <div>
                                        <h6>{{experience.jobTitle}}</h6>
                                        <!-- <p>{{experience.companyName}}</p> -->
                                    </div>
                                    <div>
                                    <ng-container *ngIf="experience?.endedMonth && experience?.endedYear; else presentTemplate" >
                                        <h6>({{experience?.startedYear}}) -  ({{experience?.endedYear}})</h6>
                                      </ng-container>
                                    
                                      <ng-template #presentTemplate>
                                        <div>
                                            <h6>({{experience?.startedYear}}) - present </h6>
                                        </div>
                                      </ng-template>                                
                                    </div>
                                    </div>
                                      </li>
                                    </ul>
                                </ng-container>
                                <ng-template #noExperience>
                                 <p>No Experience</p>
                                </ng-template>
                            </div>
                        </div>



                        <div class="single-profile-item" *ngIf="!!approvedStatus">
                            <div class="single-profile-right">
                        <div class="single-profile-textarea"> 
                            <div class="single-profile-heading">
                                <span></span>
                                <h3>Identification Documents</h3>
                            </div>
        
                            <div class="row">
                                <div class="col-lg-6">
                                <h6><b>Passport</b></h6>
                                <div *ngIf="candidateInfo.candidatePassportDetails?.length; else noPassport">
                                    <!-- Loop through all passport details -->
                                    <div *ngFor="let passport of candidateInfo.candidatePassportDetails">
                                        <div *ngIf="passport.imageUrl">
                                            <!-- Display only the image name -->
                                            <div class="d-flex">
                                                <a class="certificate" [href]="passport.imageUrl" target="_blank" rel="noopener noreferrer">
                                                    <span>{{ passport.imageName }}</span>
                                                  </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- No passport available message -->
                                <ng-template #noPassport>
                                    <p>No Passport Available</p>
                                </ng-template>
                                
                     
                                </div>
        
                                <div class="col-lg-6">
                                    <h6><b>Driving License</b></h6>
                                    <div *ngIf="candidateInfo.candidateDrivingLicenseDetails?.length; else noDriving">
                                        <!-- Loop through all passport details -->
                                        <div *ngFor="let data of candidateInfo.candidateDrivingLicenseDetails">
                                            <div *ngIf="data.imageUrl">
                                                <!-- Display only the image name -->
                                                <div class="d-flex">
                                                    <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                        <span>{{ data.imageName }}</span>
                                                      </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- No passport available message -->
                                    <ng-template #noDriving>
                                        <p>No Driving License Available</p>
                                    </ng-template>
                                    
                                    </div>
        
                               <div class="col-lg-6 mt-3">
                                <h6><b>MediCare</b></h6>
                                <div *ngIf="candidateInfo.candidateMediCareDetails?.length; else noMedicare">
                                            <!-- Loop through all passport details -->
                                <div *ngFor="let data of candidateInfo.candidateMediCareDetails">
                                <div *ngIf="data.imageUrl; else noMediImage">
                                                    <!-- Display only the image name -->
                                                    <div class="d-flex">
                                                        <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                            <span>{{ data.imageName }}</span>
                                                          </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- No passport available message -->
                                        <ng-template #noMedicare>
                                            <p>No MediCare Available</p>
                                        </ng-template>
                                        
                                        <!-- No image available message -->
                                        <ng-template #noMediImage>
                                            <p>No Image Available</p>
                                        </ng-template>
                               </div> 
                               
                               <div class="col-lg-6 mt-3">
                                <h6><b>MediBank</b></h6>
                                <div *ngIf="candidateInfo.candidateMediBankDetails?.length; else noMedicare">
                                    <!-- Loop through all passport details -->
                                    <div *ngFor="let data of candidateInfo.candidateMediBankDetails">
                                        <div *ngIf="data.imageUrl; else noMediBankImage">
                                            <!-- Display only the image name -->
                                            <div class="d-flex">
                                                <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                    <span>{{ data.imageName }}</span>
                                                  </a>
                                            
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- No passport available message -->
                                <ng-template #noMedicare>
                                    <p>No MediCare Available</p>
                                </ng-template>
                                
                                <!-- No image available message -->
                                <ng-template #noMediBankImage>
                                    <p>No Image Available</p>
                                </ng-template>
                                </div>
                            </div>
                                </div>
                            </div>
                        </div>
        
                        <div class="single-profile-item" *ngIf="!!approvedStatus">
                            <div class="single-profile-right">
                                <div class="single-profile-textarea">
                                 
                                   <div class="single-profile-heading">
                                        <span></span>
                                        <h3>Industry Currency</h3>
                                    </div>
                                    
                                    <div class="single-profile-paragraph">
                                        <ul class="unordered-list">
                                            <ng-container *ngIf="candidateInfo?.industryCurrency?.length; else noIndustryCurrency">
                                                <li *ngFor="let data of candidateInfo?.industryCurrency; let i = index">
                                                    <b>{{ i + 1 }}</b>: {{ data.industryCurrencyType }}
                                                    <span *ngIf="data.industryCurrencyExpiry"> ({{ data.industryCurrencyExpiry }}) </span>
                                    
                                                    <!-- <b><p *ngIf="data.imageName">Certificate</p></b> -->
                                    
                                                    <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                        <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                          <p class='fw-bold'>{{ data.imageName }}</p>
                                                        </a>
                                                      </div>
                                                </li>
                                            </ng-container>
                                    
                                            <!-- No Industry Currency Available -->
                                            <ng-template #noIndustryCurrency>
                                                <li>No Industry Currency Available</li>
                                            </ng-template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <div class="single-profile-item" *ngIf="!!approvedStatus">
                            <div class="single-profile-right">
                                <div class="single-profile-textarea">
                                 
                                    <div class="single-profile-heading">
                                        <span></span>
                                        <h3>Industry Currency Verification</h3>
                                    </div>
                                    
                                    <div class="single-profile-paragraph">
                                        <ul class="unordered-list">
                                         
                                <!-- Industry Currency Verification Files -->
                                <ng-container *ngIf="candidateInfo?.industryCurrencyVerification?.length; else noIndustryCurrencyVerification">
                                                <li *ngFor="let data of candidateInfo.industryCurrencyVerification; let i = index">
                                                    <b>{{ i + 1 }}</b>: {{ data.industryCurrencyVerificationType }}
                                                    <span *ngIf="data.industryCurrencyVerificationExpiry"> ({{ data.industryCurrencyVerificationExpiry }}) </span>
                                    
                                                    <!-- <b><p *ngIf="data.imageName">Certificate</p></b> -->
                                    
                                                    <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                        <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                          <p class='fw-bold'>{{ data.imageName }}</p>
                                                        </a>
                                                      </div>
                                                </li>
                                </ng-container>
                                 <!-- No Industry Currency Available -->
                                 <ng-template #noIndustryCurrencyVerification>
                                    <li>No Industry Currency Verification Available</li>
                                </ng-template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
        
        
                        <!-- <div class="single-profile-item" *ngIf="!!approvedStatus">
                            <div class="single-profile-right">
                                <div class="single-profile-textarea">
                                 
                                    <div class="single-profile-heading">
                                        <span></span>
                                        <h3>Reference Check</h3>
                                    </div>
                                    
                                    <div class="single-profile-paragraph">
                                        <ul class="unordered-list">
                                         
                                     <ng-container *ngIf="candidateInfo?.refrenceCheck?.length; else noReferenceCheck">
                                                <li *ngFor="let data of candidateInfo?.refrenceCheck; let i = index">
                                    
                                                    <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                        <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                            <p class='fw-bold'> <b>{{ i + 1 }}</b>:<span class="ms-2">{{ data.imageName }}</span></p>
                                                        </a>
                                                      </div>
                                                </li>
                                </ng-container>
                                 <ng-template #noReferenceCheck>
                                    <li>No Reference Check Available</li>
                                </ng-template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div> -->
        
                        <div class="single-profile-item" *ngIf="!!approvedStatus">
                            <div class="single-profile-right">
                                <div class="single-profile-textarea">
                                 
                                    <div class="single-profile-heading">
                                        <span></span>
                                        <h3>PD Log And Plan</h3>
                                    </div>
                                    
                                    <div class="single-profile-paragraph">
                                        <ul class="unordered-list">
                                         
                                <!-- Industry Currency Verification Files -->
                                     <ng-container *ngIf="candidateInfo?.pdLogAndPlan?.length; else noPdLogAndPlan">
                                                <li *ngFor="let data of candidateInfo?.pdLogAndPlan; let i = index">      
                                                    <b>{{ i + 1 }}</b>: {{ data.pdLogAndPlanType }}
                                                    <span *ngIf="data?.pdLogAndPlanExpiry && data.pdLogAndPlanExpiry !== 'null' && data.pdLogAndPlanExpiry.trim() !== ''"> ({{ data.pdLogAndPlanExpiry }}) </span>                      
                                                    <!-- <b><p *ngIf="data.imageName">Certificate</p></b> -->
                                    
                                                    <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                        <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                          <p class='fw-bold'>{{ data.imageName }}</p>
                                                        </a>
                                                      </div>
                                                </li>
                                    </ng-container>
                                    <!-- No Industry Currency Available -->
                                     <ng-template #noPdLogAndPlan>
                                        <li>No PD Log And Plan Available</li>
                                     </ng-template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <div class="single-profile-item" *ngIf="!!approvedStatus">
                            <div class="single-profile-right">
                                <div class="single-profile-textarea">
                                    <div class="single-profile-heading">
                                        <span></span>
                                        <h3>USI Report</h3>
                                    </div>
                                    
                                    <div class="single-profile-paragraph">
                                        <ul class="unordered-list">
                                            <!-- USI Report List -->
                                            <ng-container *ngIf="candidateInfo?.usiReport?.length; else noUsiReport">
                                                <li *ngFor="let data of candidateInfo.usiReport; let i = index">
                                                    <b>{{ i + 1 }}</b>: {{ data.usiReportType }}
                                    
                                                    <!-- <b><p *ngIf="data.imageName">Document</p></b> -->
                                    
                                                    <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                        <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                          <p class='fw-bold'>{{ data.imageName }}</p>
                                                        </a>
                                                      </div>
                                    
                                                    <!-- Expiry Date -->
                                                    <div *ngIf="data.usiReportExpiry">
                                                        <b>Expiry Date:</b> {{ data.usiReportExpiry }}
                                                    </div>
                                                </li>
                                            </ng-container>
                                    
                                            <!-- No USI Report Available -->
                                            <ng-template #noUsiReport>
                                                <li>No USI Report Available</li>
                                            </ng-template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <div class="single-profile-item " *ngIf="!!approvedStatus">
                            <div class="single-profile-right">
                                <div class="single-profile-textarea">
                                  
                                    <div class="single-profile-heading">
                                        <span></span>
                                        <h3>Trainer Matrix</h3>
                                    </div>
                                    
                                    <div class="single-profile-paragraph">
                                        <ul class="unordered-list">
                                            <!-- Matrix File -->
                                            <ng-container *ngIf="candidateInfo?.matrix?.length; else noMatrixFile">
                                                <li *ngFor="let data of candidateInfo.matrix; let i = index">
                                                    <!-- <b>{{ i + 1 }}</b>: {{ data.fieldName }} -->
                                    
                                                    <!-- <b><p *ngIf="data.imageName">Certificate</p></b> -->
                                    
                                                    <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                        <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                             <p class='fw-bold'><b>{{ i + 1 }}</b>: <span class="ms-2">{{ data.imageName }}</span></p>
                                                        </a>
                                                      </div>
                                                </li>
                                            </ng-container>
                                    
                                            <!-- No Matrix File Available -->
                                            <ng-template #noMatrixFile>
                                                <li>No Matrix File Available</li>
                                            </ng-template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <div class="single-profile-item " *ngIf="!!approvedStatus">
                            <div class="single-profile-right">
                                <div class="single-profile-textarea">
                                  
                                    <div class="single-profile-heading">
                                        <span></span>
                                        <h3>Resume</h3>
                                    </div>
                                    
                                    <div class="single-profile-paragraph">
                                        <ul class="unordered-list">
                                            <!-- Resume List -->
                                            <ng-container *ngIf="candidateInfo?.resumeDocs?.length; else noResume">
                                                <li *ngFor="let data of candidateInfo.resumeDocs; let i = index">
                                                    <b>{{ i + 1 }}</b>: {{ data.resumeType }}
                                    
                                                    <!-- <b><p *ngIf="data.imageName">Document</p></b> -->
                                    
                                                    <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                        <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                          <p class='fw-bold'>{{ data.imageName }}</p>
                                                        </a>
                                                      </div>
                                    
                                                    <!-- Expiry Date -->
                                                    <div *ngIf="data.resumeExpiry">
                                                        <b>Expiry Date:</b> {{ data.resumeExpiry }}
                                                    </div>
                                                </li>
                                            </ng-container>
                                    
                                            <!-- No Resume Available -->
                                            <ng-template #noResume>
                                                <li>No Resume Available</li>
                                            </ng-template>
                                        </ul>
                                    </div>
                                    
        
                                </div>
                            </div>
                        </div>
        
                        <div class="single-profile-item " *ngIf="!!approvedStatus">
                            <div class="single-profile-right">
                                <div class="single-profile-textarea">
                                  
                                    <div class="single-profile-heading">
                                        <span></span>
                                        <h3>Additional Certificates</h3>
                                    </div>
                                    
                                    <div class="single-profile-paragraph">
                                        <ul class="unordered-list">
                                            <!-- Additional Certificate List -->
                                            <ng-container *ngIf="candidateInfo?.candidateAdditionalCertificateDetails?.length; else noCertificate">
                                                <li *ngFor="let data of candidateInfo.candidateAdditionalCertificateDetails; let i = index">
                                                    <b>{{ i + 1 }}</b>: {{ data.additionalCertificateType }}
                                    
                                                    <!-- <b><p *ngIf="data.imageName">Document</p></b> -->
                                    
                                                    <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                        <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                          <p class='fw-bold'>{{ data.imageName }}</p>
                                                        </a>
                                                      </div>
                                    
                                                    <!-- Expiry Date -->
                                                    <div *ngIf="data.additionalCertificateExpiry">
                                                        <b>Expiry Date:</b> {{ data.additionalCertificateExpiry }}
                                                    </div>
                                                </li>
                                            </ng-container>
                                    
                                            <!-- No Certificates Available -->
                                            <ng-template #noCertificate>
                                                <li>No Additional Certificates Available</li>
                                            </ng-template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <!-- <div class="single-profile-item ">
                            <div class="single-profile-right">
                                <div class="single-profile-textarea">
                                  
                                    <div class="single-profile-heading">
                                        <span></span>
                                        <h3>Medical Certificate</h3>
                                    </div>
                                    
                                    <div class="single-profile-paragraph">
                                        <ul class="unordered-list">
                                            Medical Certificate List
                                            <ng-container *ngIf="candidateInfo?.medicalCertificate?.length; else noMedicalCertificate">
                                                <li *ngFor="let data of candidateInfo.medicalCertificate; let i = index">
                                                    <b>{{ i + 1 }}</b>: {{ data.medicalCertificateType }}
                                    
                                                    <b><p *ngIf="data.imageName">Document</p></b>
                                    
                                                    <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                        <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                          <p class='fw-bold'>{{ data.imageName }}</p>
                                                        </a>
                                                      </div>
                                    
                                                    Expiry Date
                                                    <div *ngIf="data.medicalCertificateExpiry">
                                                        <b>Expiry Date:</b> {{ data.medicalCertificateExpiry }}
                                                    </div>
                                                </li>
                                            </ng-container>
                                    
                                            No Medical Certificate Available
                                            <ng-template #noMedicalCertificate>
                                                <li>No Medical Certificate Available</li>
                                            </ng-template>
                                        </ul>
                                    </div> 
                                </div>
                            </div>
                        </div> -->
        
                        <div class="single-profile-item" *ngIf="!!approvedStatus">
                            <div class="single-profile-right">
                                <div class="single-profile-textarea">
                                 
                                    <div class="single-profile-heading">
                                        <span></span>
                                        <h3>Professional Development</h3>
                                    </div>
                                    
                                    <div class="single-profile-paragraph">
                                        <ul class="unordered-list">
                                         
                                <!-- pd Files -->
                                <ng-container *ngIf="candidateInfo?.pds?.length; else noPd">
                                    <li *ngFor="let data of candidateInfo?.pds; let i = index">      
                                        <b>{{ i + 1 }}</b>: {{ data.pdsType }}
                                        <span *ngIf="data.pdsExpiry && data.pdsExpiry !== 'null'"> ({{ data.pdsExpiry }}) </span>                      
                                        
                                        <!-- <b><p *ngIf="data.filesDetails.imageName">Certificate</p></b> -->
                                
                                        <div *ngIf="data.filesDetails.imageName" class="d-flex align-items-center">
                                            <a class="certificate" [href]="data.filesDetails.imageUrl" target="_blank" rel="noopener noreferrer">
                                              <p class='fw-bold'>{{ data.filesDetails.imageName }}</p>
                                            </a>
                                          </div>
                                    </li>
                                </ng-container>
                                    <!-- No Industry Currency Available -->
                                     <ng-template #noPd>
                                        <li>No PD Available</li>
                                     </ng-template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="single-profile-item" *ngIf="!!approvedStatus">
                            <div class="single-profile-right">
                                <div class="single-profile-textarea">
                                 
                                    <div class="single-profile-heading">
                                        <span></span>
                                        <h3>Candidate Contracts</h3>
                                    </div>
                                    
                                    <div class="single-profile-paragraph">
                                        <ul class="unordered-list">
                                         
                                
                                <ng-container *ngIf="candidateContractDetails?.length; else noContract">
                                    <li *ngFor="let data of candidateContractDetails; let i = index">      
                                        <!-- <b>{{ i + 1 }}</b>: {{ data.pdsType }}
                                        <span *ngIf="data.pdsExpiry"> ({{ data.pdsExpiry }}) </span>                       -->
                                        
                                        <!-- <b><p *ngIf="data.filesDetails.imageName">Certificate</p></b> -->
                                         <div class="row">
        
                                            <div class="col-lg-3">
                                         <b>{{ i + 1 }}</b>-<b>Commencement Date</b><br>
                                         <span>{{data?.commencementDate}}</span><br>
                                        </div>
        
                                        <div class="col-lg-3">
                                         <b>End Date</b><br>
                                         <span>{{data?.endDate}}</span>
                                        </div>
        
                                        <div class="col-lg-3">
                                            <b>Contract Name</b><br>
                                            <span>{{data?.contractType}}</span>
                                        </div>
        
                                        <div class="col-lg-8">
                                            <b *ngIf="data?.pdfFile?.imageName">Contract Pdf</b><br>
                                            <div *ngIf="data?.pdfFile?.imageName" class="d-flex align-items-center">
                                                <a class="certificate" [href]="data?.pdfFile?.imageUrl" target="_blank" rel="noopener noreferrer">
                                                  <p >{{ data?.pdfFile?.imageName }}</p>
                                                </a>
                                              </div>
                                        </div>
        
                                        </div>
                                        
                                    </li>
                                </ng-container>
                                    <!-- No Contract Available -->
                                     <ng-template #noContract>
                                        <li>No Contract Available</li>
                                     </ng-template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>